module.exports = __webpack_public_path__ + "static/img/secondary_placeholder.93bf89c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholder/secondary_placeholder.png
// module id = aBfH
// module chunks = 7